"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentService = void 0;
var app_1 = require("./app");
var ComponentService = /** @class */ (function () {
    function ComponentService() {
        var _this = this;
        this.components = [];
        this.pendingUpdateComponent = [];
        $(function () {
            app_1.PageService.Init();
            _this.InitComponents();
            app_1.PageService.AttachOnBodyClickHadlers();
            app_1.PageService.AttachOnWindowResizeHandlers();
            app_1.PageService.AttachOnWindowResizeThrottleHandlers();
            app_1.PageService.AttachOnPopStateHandlers();
            app_1.PageService.AttachOnScrollThrottleHandler();
            app_1.PageService.AttachOnHashChangeHandler();
            app_1.PageService.AttachOnPageLoadHandler();
            app_1.PageService.AttachOnTouchStartHandler();
            app_1.PageService.AttachOnTouchEndHandler();
        });
    }
    ComponentService.prototype.AddComponent = function (component) {
        this.components.push(component);
    };
    ComponentService.prototype.AddPendingUpdateComponent = function (component) {
        if (this.pendingUpdateComponent.indexOf(component) == -1) {
            this.pendingUpdateComponent.push(component);
        }
    };
    ComponentService.prototype.UpdateComponentsSelector = function () {
        this.pendingUpdateComponent.forEach(function (component) {
            if (component.selector) {
                component.$el = $(component.selector);
                if (component.$el.length > 0) {
                    component.OnInstancesUpdated();
                }
            }
        });
        this.pendingUpdateComponent = [];
    };
    ComponentService.prototype.InitComponents = function () {
        this.components.forEach(function (component) {
            if (component.selector) {
                component.$el = $(component.selector);
                if (!component.$el.length && component.skipInitIfNotOnPage) {
                    return;
                }
            }
            component.BeforeInit && component.BeforeInit();
            component.OnInit && component.OnInit();
            component.OnBodyClick && app_1.PageService.AddOnBodyClickHandler(component.OnBodyClick.bind(component));
            component.OnWindowResize && app_1.PageService.AddOnWindowResizeHandler(component.OnWindowResize.bind(component));
            component.OnWindowResizeThrottle &&
                app_1.PageService.AddOnWindowResizeThrottleHandler(component.OnWindowResizeThrottle.bind(component));
            component.OnPopStateHandler &&
                app_1.PageService.AddOnPopStateHandler(component.OnPopStateHandler.bind(component));
            component.OnScrollThrottle &&
                app_1.PageService.AddOnScrollThrottleHandler(component.OnScrollThrottle.bind(component));
            component.OnHashChange &&
                app_1.PageService.AddOnHashChangeHandler(component.OnHashChange.bind(component));
            component.OnPageLoad &&
                app_1.PageService.AddOnPageLoadHandler(component.OnPageLoad.bind(component));
            component.OnTouchStart &&
                app_1.PageService.AddOnTouchStartHandler(component.OnTouchStart.bind(component));
            component.OnTouchEnd &&
                app_1.PageService.AddOnTouchEndHandler(component.OnTouchEnd.bind(component));
        });
    };
    return ComponentService;
}());
var service = new ComponentService();
exports.ComponentService = service;
